/* eslint-disable eqeqeq */
import React from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Icon, Input, Button, Checkbox, Card, Row, Col } from "antd";
import "./Injaz-LoginScreen.css";
import LanguageChangingDropdown from "../../components/LanguageChangingDropdown";
import { loginThunk } from "../../redux/actions/loginAction";
import { parametersListByParaType } from "../../redux/actions/parametersAction";
import { FaUser } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
const FormItem = Form.Item;

class NormalLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  componentDidMount() {
    localStorage.setItem("lang", "AR");
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const body = {
          usernameOrEmail: values.email,
          password: values.password,
        };
        this.props.loginThunk(body);
        this.getParameters();
      }
    });
  };

  getParameters = () => {
    if (!this.props.user.accessToken) {
      if (this.props.user == true) {
        setTimeout(() => {
          this.getParameters();
        }, 200);
      } else {
        this.setState({ loading: false });
      }
    } else {
      let payload = {
        data: {
          paraType: "SCREEN_GROUP",
          lang: localStorage.getItem("lang"),
        },
        accessToken: this.props.user.accessToken,
        tokenType: this.props.user.tokenType,
      };
      this.props.parametersAction(payload);
      console.log("asddsa");
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { props } = this;
    const lang = props.language.INJAZ_AUTH_LOGINFORM;
    const direction = props.language.INJAZ_AUTH_DIRECTION;
    if (
      parseInt(this.props.user.clientId) === 0 &&
      this.props.user.accessToken
    ) {
      return (
        <Redirect
          to={{
            pathname: "/selectclient",
          }}
        />
      );
    } else if (
      this.props.user.clientId &&
      this.props.user.accessToken &&
      localStorage.getItem("accessToken")
    ) {
      if (JSON.parse(localStorage.getItem("userData")).isPosUser) {
        return (
          <Redirect
            to={{
              pathname: "/dashboard/pos",
            }}
          />
        );
      } else {
        this.getParameters();
        return (
          <>
            <Redirect
              to={{
                // pathname: "/dashboard"
                pathname: "/dashboard/pos",
              }}
            />
          </>
        );
      }
    } else {
      // loginform login-form
      return (
        <Card className="logincardnew">
          <div className="wrapperLogin">
            <div className="image">
              <p>تسجيل الدخول</p>
              <p>اوردر اكس</p>
              <img
                className="subLogoLogin"
                src="subLogoLogin.jpeg"
                alt="logo"
              />
            </div>
            <div className="contetnLogin">
              <div className="title">
                <img className="logoMain" src="logoMain.png" alt="logo" />
                {/* <div>
                  <LanguageChangingDropdown style={{ fontColor: "#c00" }} />
                </div> */}
              </div>
              <form onSubmit={this.handleSubmit}>
                <div className="login-item">
                  {getFieldDecorator("email", {
                    rules: [
                      {
                        required: true,
                        message: "يرجى إدخال بريدك الإلكتروني!",
                      },
                    ],
                  })(
                    <div className="inpIcon">
                      <i>
                        <FaUser />
                      </i>
                      <input
                        placeholder={"البريد الإلكتروني"}
                        dir={direction}
                      />
                    </div>,
                  )}
                </div>
                <div className="login-item">
                  {getFieldDecorator("password", {
                    rules: [
                      {
                        required: true,
                        message: "الرجاء إدخال كلمة المرور الخاصة بك!",
                      },
                    ],
                  })(
                    <div className="inpIcon">
                      <i>
                        <RiLockPasswordFill />
                      </i>
                      <input
                        type="password"
                        placeholder={"كلمة المرور"}
                        dir={direction}
                      />
                    </div>,
                  )}
                </div>
                <div className="wrapperBtns">
                  <button
                    loading={this.state.loading}
                    block
                    className="submit btnLogin"
                    htmlType="submit"
                  >
                    {"ارسال"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Card>
      );
    }
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loginThunk: (body) => dispatch(loginThunk(body)),
    parametersAction: (payload) => dispatch(parametersListByParaType(payload)),
  };
};
const WrappedNormalLoginForm = Form.create()(NormalLoginForm);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(WrappedNormalLoginForm));
